import { render, staticRenderFns } from "./TerritoryLookup.vue?vue&type=template&id=74af1afd"
import script from "./TerritoryLookup.vue?vue&type=script&lang=ts"
export * from "./TerritoryLookup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports